<div provide-parent-form *ngIf="datafeed">
	<bb-form-element [form]="form" [label]="'DATAFEED_TYPE' | translate">
		<bb-select [(ngModel)]="datafeed.feedType" name="feedType" [options]="feedTypeOptions"
			(ngModelChange)="onFeedTypeChanged(datafeed.feedType)"
			[disabled]="!!datafeed?.id && datafeed?.id !== 'new'"></bb-select>
	</bb-form-element>

	<ng-container *ngIf="datafeed.feedType === 'xmlUploadImport'">
		<bb-form-element [label]="'TRANSFER_PROTOCOL' | translate"
			(ngInit)="datafeed.transferprotocol = datafeed.transferprotocol || 'ftp'">
			<bb-select [(ngModel)]="datafeed.transferprotocol" name="transferprotocol">
				<option value="s3">{{ 'XML_S3_FEED' | translate }}</option>
				<option value="ftp">{{ 'XML_FTP_FEED' | translate }}</option>
			</bb-select>
		</bb-form-element>

		<bb-form-element *ngIf="datafeed.feedUrl" [label]="'XML_FEED_URL' | translate"
			[helpMessage]="'HELP.DATAFEED_URL' | translate">
			<div class="input">{{datafeed.feedUrl}}
				<button class="button right" [title]="'COPY_TO_CLIPBOARD' | translate" (click)="copyToClipboard(datafeed.feedUrl, 'URL_COPIED_TO_CLIPBOARD')">
					<i class="fa fa-copy"></i> {{ 'COPY' | translate }}
				</button>
			</div>
		</bb-form-element>
	</ng-container>

	<bb-form-element [form]="form" label="{{'NAME' | translate}}" (ngInit)="onNameInit()">
		<input [(ngModel)]="datafeed.name" type="text" name="name" required />
	</bb-form-element>

	<ng-container *ngIf="datafeed.feedType === 'xmlUploadImport'">
		<bb-form-element [form]="form" [label]="'CODE' | translate" [helpMessage]="'HELP.DATAFEED_CODE' | translate">
			<input [class.disabled]="datafeed?.id" [(ngModel)]="datafeed.code" type="text" name="code"
				(ngModelChange)="updateCode(datafeed.code)" />
			<!-- <bb-text [class.disabled]="datafeed?.id" [(ngModel)]="datafeed.code" type="text" name="code" (ngModelChange)="onCodeUpdated(datafeed.code)"></bb-text> -->
		</bb-form-element>
	</ng-container>

	<bb-form-element [form]="form" [label]="'DESCRIPTION' | translate">
		<textarea [(ngModel)]="datafeed.description" type="text" name="description"></textarea>
	</bb-form-element>

	<ng-container *ngIf="datafeed.feedType === 'rssFeedImport'">
		<bb-form-element [label]="'MEDIA_FILE_BEHAVIOUR' | translate"
			(ngInit)="datafeed.assetHost = datafeed.assetHost || 'useSource'">
			<bb-select [(ngModel)]="datafeed.assetHost" name="assetHost">
				<option value="useSource">{{ 'USE_SOURCE_MEDIA' | translate }}</option>
				<option value="copySource">{{ 'COPY_AND_HOST_MEDIA' | translate }}</option>
				<option value="retranscode" [hasPublicationField]="'transcodeImportedItems'">{{ 'RETRANSCODE_MEDIA' |
					translate }}</option>
			</bb-select>
		</bb-form-element>

		<bb-form-element [label]="'AUTOPUBLISH_IMPORTED_ITEMS' | translate">
			<bb-check [(ngModel)]="datafeed.autoPublish" name="autoPublish"></bb-check>
		</bb-form-element>
	</ng-container>

	<ng-container *ngIf="datafeed.feedType === 'rssFeedImport' || datafeed.feedType === 'xmlUploadImport'">
		<bb-form-element [label]="'UPLOAD_WITH_PRESETS' | translate">
			<mat-form-field appearance="fill" class="full-width">
				<mat-label>{{"SELECT_PRESET" | translate}}</mat-label>
				<mat-select [(ngModel)]="datafeed.transcodingProfile" name="transcodingProfile" #matSelect>
					<mat-option *ngFor="let profile of mediaProfiles" [value]="profile.name">
						{{ profile.name }}
						<i *ngIf="profile.label === 'Custom'" (click)="deleteProfile(profile)" class="button fa fa-trash"></i>
					</mat-option>
					<div class="mat-option create-preset" (click)="createPreset()">
						{{ 'CREATE_PRESET' | translate }} 
						<i class="fa-solid fa-arrow-right"></i>
					</div>
				</mat-select>
			</mat-form-field>
		</bb-form-element>
	</ng-container>

	<ng-container *ngIf="datafeed.feedType === 'renderedVideo'">
		<h3>{{ 'BBRENDER_CONFIGURATION' | translate }}</h3>
		<bb-form-element [label]="'BBRENDER_CRON' | translate" [helpMessage]="'HELP.BBRENDER_CRON' | translate">
			<div class="input">
				<bb-cron name="scheduler-cron" [(ngModel)]="datafeed.schedulerCron" class="input"></bb-cron>
			</div>
		</bb-form-element>

		<bb-form-element [label]="'BBRENDER_MIN_BATCH_SIZE' | translate"
			[helpMessage]="'HELP.BBRENDER_MIN_BATCH_SIZE' | translate">
			<input type="number" name="scheduler-min-batch-size" [(ngModel)]="datafeed.schedulerMinBatchSize" [min]="0"
				[placeholder]="0" />
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'BBRENDER_CALLBACK_URL' | translate"
			[helpMessage]="'HELP.BBRENDER_CALLBACK_URL' | translate">
			<input [(ngModel)]="datafeed.callbackUrl" type="text" name="callbackUrl"
				(ngModelChange)="onCallbackUrlChanged(datafeed.callbackUrl)" />
		</bb-form-element>
	</ng-container>

	<h3>{{ 'DATA' | translate }}</h3>

	<div *ngIf="datafeed?.feedType">
		<bb-data-grid [(ngModel)]="datafeed" name="datafeed-data" [form]="form"></bb-data-grid>
	</div>
</div>

<ng-template #createPresetTemplate>
	<bb-create-preset (modalClose)="closeModal($event)"></bb-create-preset>
</ng-template>
